import { render, staticRenderFns } from "./UHFSensorAccessoriesOverview.vue?vue&type=template&id=3196ff9a&scoped=true&lang=pug"
import script from "./UHFSensorAccessoriesOverview.vue?vue&type=script&lang=js"
export * from "./UHFSensorAccessoriesOverview.vue?vue&type=script&lang=js"
import style0 from "./UHFSensorAccessoriesOverview.vue?vue&type=style&index=0&id=3196ff9a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3196ff9a",
  null
  
)

export default component.exports